import { render, staticRenderFns } from "./LastShipmentPrice.vue?vue&type=template&id=062d8949"
import script from "./LastShipmentPrice.vue?vue&type=script&lang=js"
export * from "./LastShipmentPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports